import { forwardRef, createElement } from 'react';
import * as icons from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { ConfigProvider } from 'antd';
const { createFromIconfontCN } = icons;
const Icon = (props, ref) => {
    const { type = '', size, color, ...rest } = props;
    const IconComp = (icons || {})[type];
    const style = {
        ...rest.style,
        fontSize: size,
        color,
    };
    if (!IconComp) {
        const IconFont = createFromIconfontCN();
        return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
            createElement(IconFont, { type: type, ...rest, style: style, ref: ref })));
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(IconComp, { ...rest, style: style, twoToneColor: color, ref: ref })));
};
export default forwardRef(Icon);
